import { useAuthStore } from '@/modules/auth/stores/auth.store'

export function useMenuAuthorization() {
  const authStore = useAuthStore()

  const hasRolePermission = (allowedRoles) => {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true
    }
    return authStore.userRoles?.some(role => allowedRoles.includes(role))
  }

  const isModuleEnabled = (moduleName) => {
    if (!moduleName) {
      return true
    }
    return authStore.tenantData?.enabledModules?.includes(moduleName)
  }

  const filterAuthorizedItems = (item) => {
    const tenantData = authStore.tenantData
    const companyData = authStore.companyData

    if (item.allowedRoles && item.allowedRoles.length > 0) {
      if (!hasRolePermission(item.allowedRoles)) {
        return null
      }
    }

    if (item.module) {
      if (!isModuleEnabled(item.module)) {
        return null
      }
    }

    if (item.allowedFlag && (!tenantData[item.allowedFlag] && !companyData[item.allowedFlag])) {
      return null
    }

    if (item.children && item.children.length > 0) {
      const filteredChildren = item.children
        .map(child => filterAuthorizedItems(child))
        .filter(Boolean)

      if (filteredChildren.length === 0) {
        return null
      }

      return {
        ...item,
        children: filteredChildren,
      }
    }

    return item
  }

  return {
    filterAuthorizedItems,
    hasRolePermission,
    isModuleEnabled,
  }
}
